import React from "react";
import { isBrowser } from "react-device-detect";
import SafeCallComponent from "../LabOrderItem/children/SafeCallComponent";
import {useDispatch, useSelector} from 'react-redux';
import { samplingDone } from "../../../../../redux/actions/orders";
import CustomButton from "../../../../../components/CustomButton";
const LabOrderWaitingForSamplingActions = (props) => {
  const dispatch = useDispatch();
  const {id, order_type} = props;
  const { sampling_done_waiting } = useSelector((state) => state.orders);
  const submit = () => {
    dispatch(samplingDone(id));
  };
  let title = "نمونه‌گیری انجام شد";
  if(order_type === 'home_care'){
    title = "خدمات انجام شد"
  }
  return (
    <>
      <div className={isBrowser ? "flex-column waiting-for-price-buttons" : "flex-column waiting-for-price-buttons-mobile"}>
        <SafeCallComponent order={props} />
        <CustomButton 
                className="btn btn-small btn-success text-white full-width"
                action={submit}
                content={title}
                block={true}
                type={'success'}
                loading={sampling_done_waiting}
                textWhite={true}
              />
      </div>
    </>
  );
};

export default LabOrderWaitingForSamplingActions;
